var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElement1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.8 73.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8571ba;}.cls-2{fill:#050409;}.cls-3{fill:none;stroke:#050409;stroke-miterlimit:10;}.cls-4{fill:#ee91c0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32-4",
    "data-name": "Path 32-4",
    className: "cls-1",
    d: "M.33,58c-1-2.54.34-5.67,1.86-7.44,2.74-3.18,6.08-1.78,10.69-3.71,7.06-3,5.87-9,13.93-15.8,5.75-4.84,7-2.28,13-7,8.92-6.92,6.92-13,14.87-18.12,3.07-2,7.47-2.72,16.26-4.19C80.75.12,85.82-.73,92.33.82c5.29,1.25,6.08,2.8,13,4.18,7.33,1.46,7.92,0,11.61,1.39,7.87,2.91,6.17,9.78,14.4,15.33,7.87,5.3,13.44,1.77,17.66,7.44,3.16,4.24.94,7.42,4.65,11.61,3,3.36,5.5,2.59,11.61,5.58,8.89,4.34,15.54,11.83,14.4,13.94-.91,1.7-6.75-.3-7.43,1.39s4.2,4,3.72,5.58c-.64,2.1-9.7.56-22.77,0-8.32-.36-14.63-.16-19.52,0-12.68.42-19,.63-22.76,1.86-5,1.63-8.1,3.68-13,2.78-3.85-.7-4-2.33-8.37-3.71-6.56-2.06-12.73-.46-16.26.46-8.25,2.15-8.2,5-13,4.65-1.88-.14-2.52-.63-13-5.58-4.41-2.08-6.62-3.13-7-3.25-7.05-2.55-10.6-.33-20-.46C15.48,63.94,2.52,63.75.33,58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33-4",
    "data-name": "Path 33-4",
    className: "cls-2",
    d: "M30.07,56.57c5.74-4.37,7.14-3.81,9.29-6.5,3-3.71,1.38-6.11,4.18-8.82s5.2-1.48,9.29-2.79C60.58,36,64.42,27.88,69.1,18c2.16-4.56,5-10.59,3.25-12.08S66,7.68,61.66,10.58c-8.55,5.73-8.73,9-16.26,13.94C38.93,28.8,38.3,27,33.25,31.09s-10,10.37-11.41,12.08c-3.2,4-4,5.55-6.45,6.45-3.67,1.33-6.27-.5-8.93,1.49C4.89,52.28,3.54,54.61,4,56.56c1.1,4.92,13.7,8.6,21,4.3C26.73,59.83,26.24,59.48,30.07,56.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34-4",
    "data-name": "Path 34-4",
    className: "cls-3",
    d: "M89.61,8.91a11.85,11.85,0,0,1,6.23,7.69,11.33,11.33,0,0,1-.73,7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35-4",
    "data-name": "Path 35-4",
    className: "cls-3",
    d: "M71.3,33.08a53.1,53.1,0,0,0,6.22,7.33,54.13,54.13,0,0,0,8.79,7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36-4",
    "data-name": "Path 36-4",
    className: "cls-3",
    d: "M50.78,63.85A51.19,51.19,0,0,1,61,37.48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37-4",
    "data-name": "Path 37-4",
    className: "cls-3",
    d: "M68.73,26.12c1.1-2,2.2-4.09,3.3-6.23q1.53-3,2.93-5.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38-4",
    "data-name": "Path 38-4",
    className: "cls-3",
    d: "M110.12,62.39c-1.74-3.23-2.88-6.8-1.46-9.53,1.07-2.06,2.84-2.18,4.4-4.4,2.33-3.33,1.52-7.64,1.1-9.89-1.66-8.8-9.65-13.66-11.36-14.65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39-4",
    "data-name": "Path 39-4",
    className: "cls-3",
    d: "M121.11,40.77c1.54,1.89,3.24,3.86,5.13,5.86,1.36,1.44,2.71,2.78,4,4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-4",
    "data-name": "Path 40-4",
    className: "cls-3",
    d: "M151.15,45.17a14.55,14.55,0,0,0,2.56,5.49c1.88,2.45,3.93,3.4,6.6,5.13a49.49,49.49,0,0,1,8.05,6.59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41-4",
    "data-name": "Path 41-4",
    className: "cls-3",
    d: "M119.28,19.16c.26,4.88,1.8,7,3.3,8.06,3.4,2.34,7.85-.2,11,2.56a7.43,7.43,0,0,1,2.2,4.77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42-4",
    "data-name": "Path 42-4",
    className: "cls-3",
    d: "M65.07,55.79a18.26,18.26,0,0,0-4,12.82"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43-4",
    "data-name": "Path 43-4",
    className: "cls-3",
    d: "M92.91,57.62a9.7,9.7,0,0,1,4.76,5.13,9.56,9.56,0,0,1,.37,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44-4",
    "data-name": "Path 44-4",
    className: "cls-3",
    d: "M73.13,54.69a19.83,19.83,0,0,0,4.39,8.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45-4",
    "data-name": "Path 45-4",
    className: "cls-3",
    d: "M80.09,55.43c1.64,4.65,3.76,6.33,5.49,7,1.47.53,2.57.27,4.4,1.1a10.36,10.36,0,0,1,4.4,4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46-4",
    "data-name": "Path 46-4",
    className: "cls-3",
    d: "M137.23,52.86A13.44,13.44,0,0,1,143.09,58a13.22,13.22,0,0,1,1.83,5.13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47-4",
    "data-name": "Path 47-4",
    className: "cls-3",
    d: "M118.18,54a24.62,24.62,0,0,0,2.93,3.66A24.2,24.2,0,0,0,127,62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48-4",
    "data-name": "Path 48-4",
    className: "cls-3",
    d: "M130.64,56.52a5.72,5.72,0,0,0,1.46,3.3,5.9,5.9,0,0,0,4,1.84"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49-4",
    "data-name": "Path 49-4",
    className: "cls-4",
    d: "M78.25,8.17c5,1.22,8.87.13,15.75-1.83,1.85-.52,3.29-1,3.32-1.75,0-1.2-3.9-2.23-5-2.51-3.11-.82-5.5-.82-9.31-.78a60.35,60.35,0,0,0-9,.82c-3.7.6-4,1-4.07,1.27C69.68,4.67,74,7.15,78.25,8.17Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement1);
export default __webpack_public_path__ + "static/media/Element1.daf3c86953e074ef303a3acec1e8be0a.svg";
export { ForwardRef as ReactComponent };